import { Component } from "react";

import HeaderRouteName from "../components/HeaderRouteName";

export default class ConfirmationRequest extends Component {
  render() {
    return (
      <div className="border-bottom white-bg dashboard-header">
        <HeaderRouteName nestedRouteNames={["Request"]} />
      </div>
    );
  }
}
